import React, { Component } from 'react';

import { StyledSeparatorSideBar } from './styles/StyledSeparatorSideBar';

class SeparatorSideBar extends Component {
  render() {
    return (
      <StyledSeparatorSideBar>
        <div className="btn-sidebar-separator disable-select btn-sidebar-separator-down">
          <i className="fa fa-angle-down" aria-hidden="true"></i>
        </div>
        <div className="btn-sidebar-separator disable-select btn-sidebar-separator-right">
          <i className="fa fa-angle-right" aria-hidden="true"></i>
        </div>
      </StyledSeparatorSideBar>
    );
  }
}

export default SeparatorSideBar;